module.exports = __webpack_public_path__ + "static/1-91af55293c1351a3e763e42caa0297e9.jpg";